import { render, staticRenderFns } from "./PopupModal.vue?vue&type=template&id=3416654e&scoped=true"
import script from "./PopupModal.vue?vue&type=script&lang=js"
export * from "./PopupModal.vue?vue&type=script&lang=js"
import style0 from "./PopupModal.vue?vue&type=style&index=0&id=3416654e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3416654e",
  null
  
)

export default component.exports